import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operators" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "emq-table-footer" }

import { getBrandAuthList, upsertBrandAuth } from '@/api/operation'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import BrandAuthOperatorUpsert from './BrandAuthOperatorUpsert.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'


import { defineComponent, ref, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'BrandAuthOperators',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  brandId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { t } = useI18nTl('Evses')

const showDialog = ref(false)
const showOperator: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, getCountry, getCurrency, getCurrencySymbol } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const addAuthOperator = () => {
  showDialog.value = true
  showOperator.value = undefined
}

const unauthOperator = async (operator: any) => {
  try {
    await ElMessageBox.confirm(t('Operation.unauthOperator') + operator.name + ' ?', {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })

    await upsertBrandAuth({ id: props.brandId, operatorId: operator.id, isUnauth: true })
    ElMessage.success(t(`Base.opSuccess`))
    loadTableData({ page: 1 })
  } catch (error) {
    console.error('unauth error:', error)
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  console.log('params', params.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, operatorName } = params
  newParams = {
    id: id || undefined,
    operatorName: operatorName || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    id: props.brandId,
  }

  try {
    const { list = [], pageReply = {} } = await getBrandAuthList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addAuthOperator()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.auth')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'brandAuth']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadTableData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (_unref(checkMenuShow)('operatorInfo'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
                name: 'operator-detail',
                params: { id: row.id },
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        content: row.id,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(PreWithEllipsis, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    content: row.id,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PreWithEllipsis, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["content"]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "company",
            "min-width": "120",
            label: _ctx.$t('Operation.company')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "country",
            "min-width": "80",
            label: _ctx.$t('Operation.country')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(getCountry)(Number(row.country))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation",
            "min-width": "50"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (unauthOperator(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.unauth')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'brandAuth']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(BrandAuthOperatorUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        brandId: props.brandId,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "brandId"])
    ])
  ]))
}
}

})